import { render, staticRenderFns } from "./PageCulturalOrganizations.vue?vue&type=template&id=10c8f76a&"
import script from "./PageCulturalOrganizations.vue?vue&type=script&lang=js&"
export * from "./PageCulturalOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c8f76a')) {
      api.createRecord('10c8f76a', component.options)
    } else {
      api.reload('10c8f76a', component.options)
    }
    module.hot.accept("./PageCulturalOrganizations.vue?vue&type=template&id=10c8f76a&", function () {
      api.rerender('10c8f76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/culturalOrganizations/PageCulturalOrganizations.vue"
export default component.exports